import { render, staticRenderFns } from "./Ribbon.vue?vue&type=template&id=a256c0da&scoped=true"
import script from "./Ribbon.vue?vue&type=script&lang=js"
export * from "./Ribbon.vue?vue&type=script&lang=js"
import style0 from "./Ribbon.vue?vue&type=style&index=0&id=a256c0da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a256c0da",
  null
  
)

export default component.exports